module.exports = __webpack_public_path__ + "static/media/ICONS-FOOD_&_AGRICULTURE.9c2be690.svg";